export const API_VERSION = "v1.0";

export const RAZORPAY_KEY = "rzp_live_w5f0dP26ze1P1n";
// export const RAZORPAY_KEY = "rzp_test_hhZkDMuBOyXGcy";
export const ADVERTISE_SUBMIT_EMAIL = "hitesh.mistry@binarynumbers.io";
export const CONTACT_US_SUBMIT_EMAIL = "hitesh.mistry@binarynumbers.io";

// LIVE
export const BASEURL = "https://mirajcinemas.com/api";
export const IMAGEURL = "https://mirajcinemas.com";

// export const BASEURL = "http://localhost:9001/api";
// export const IMAGEURL = "http://localhost:9001";

// DEV
// export const BASEURL = "https://uat.mirajcinemas.com/api";
// export const IMAGEURL = "https://uat.mirajcinemas.com";

// UAT
// export const BASEURL = "http://103.124.122.42:81/api";
// export const IMAGEURL = "http://103.124.122.42:81";

export const ALLOW_DELIVERY = false;
export const PAY_LATER_ALLOWED_TIME = 4;
export const COD_ALLOWED_TIME = 4;
export const GROUP_BOOKING_ALLOWED_TIME = 4;
export const GOOGLE_AUTH_CREDENTIALS = "797277865145-0l8d3jrgeutj8uavcmiulqb2t488a7sk.apps.googleusercontent.com";
export const FACEBOOK_APP_ID = "757517344803228";
export const MAX_SEAT_LIMIT = 9; //It is 10

export const FOOTER_TEXT_1 = `Miraj Entertainment Limited - U92100RJ2008PLC026391`;
export const FOOTER_TEXT_2 = `Anoli Holdings Limited - U65990GJ1981PTC004587`;
export const comming_soon = false;



// WEBPACK FOOTER //
// ./src/config/index.js